import $ from 'jquery';

function init() {
  arrowClick();
}

function arrowClick() {
  if ($('.featProd-container').length) {
    if ($('.featProd-container .prodCard').length > 3) {
      $('.featProd-arrow').addClass('featProd-arrow--visible')
      $('.featProd-arrow').on("click", function(e) {
        e.preventDefault()
        const $slider = $('.featProd-container')
        const containerScroll = $slider.scrollLeft()
        let cardSize = $('.featProd-container .prodCard').outerWidth()
        if ($(this).hasClass('featProd-arrow--prev')) {
          cardSize = -cardSize
        }
        $slider.animate({
          scrollLeft: containerScroll + cardSize
        }, 300, 'swing')
      })
    }
  }

  $('.cart-upsellArrow').on("click", function(e) {
    e.preventDefault()
    const $slider = $('.cart-upsellItems')
    const sliderScroll = $slider.scrollLeft()
    let cardSize = $('.cart-upsellItems .cart-upsellItem').outerWidth()
    if ($(this).hasClass('cart-upsellArrow--prev')) {
      cardSize = -cardSize
    }
    $slider.animate({
      scrollLeft: sliderScroll + cardSize
    }, 300)
  })

  if ($('.pdp-upsell').length) {
    if ($('.pdp-upsell .upsellCard').length > 3) {
      $('.pdp-upsellArrow').on("click", function(e) {
        e.preventDefault()
        const $slider = $('.pdp-upsell')
        const sliderScroll = $slider.scrollLeft()
        let cardSize = $('.pdp-upsell .upsellCard').outerWidth()
        if ($(this).hasClass('pdp-upsellArrow--prev')) {
          cardSize = -cardSize
        }
        $slider.animate({
          scrollLeft: sliderScroll + cardSize
        }, 300)
      })
    }
  }
}

$(function(){
  init()
});